import React from 'react'
import { Button, Typography } from '@s4l/ds'
import { IconArrowRight } from '@s4l/icons/IconArrowRight'
import { useS4LContext } from '@s4l/react-context'
import Image from '../../../Atoms/Image'
import { useBanner } from '../hooks'
import type { BannersJSON } from '../types'
import { BANNER_TYPES } from '../types'
import styles from './index.module.css'

interface BlockProps {
  bannersJSON?: BannersJSON
}

function Block({ bannersJSON }: Readonly<BlockProps>) {
  const { i18n } = useS4LContext()
  const { bannerInformation } = useBanner({
    bannersJSON,
    bannerType: BANNER_TYPES.BLOCK,
  })

  if (!bannerInformation) return null

  return (
    <section className={styles.releaseBanner}>
      <div className={styles.mainContainer}>
        <div className={styles.innerContainer}>
          <div className={styles.textContainer}>
            <Typography variant="title" size="m" as="h4">
              {bannerInformation.title[0].translated
                ? bannerInformation.title[0].text
                : i18n.formatMessage({ id: bannerInformation.title[0].text ?? '' })}
            </Typography>
            <Typography variant="body" size="l" as="p">
              {bannerInformation.description?.translated
                ? bannerInformation.description.text
                : i18n.formatMessage({ id: bannerInformation.description?.text ?? '' })}
            </Typography>
          </div>
          <Button
            variant="filled-rounded"
            trailingIcon={<IconArrowRight />}
            size="small"
            as="a"
            href={bannerInformation.url}
          >
            {bannerInformation.ctaText?.translated
              ? bannerInformation.ctaText.text
              : i18n.formatMessage({ id: bannerInformation.ctaText?.text ?? '' })}
          </Button>
        </div>
        <Image.Picture
          images={bannerInformation.image.srcSet}
          alt={
            bannerInformation.image.alt.translated
              ? (bannerInformation.image.alt.text ?? '')
              : i18n.formatMessage({ id: bannerInformation.image.alt.text ?? '' })
          }
          loading="lazy"
          aspectRatio="1"
          layout="cover"
        />
      </div>
    </section>
  )
}

Block.displayName = 'Block'
export default Block
